export const playAudio = (audio, onError) => {
  if (!audio) {
    if (onError) onError(new Error("Audio element is not available."));
    return Promise.resolve();
  }

  try {
    audio.currentTime = 0;
  } catch (e) {
    // ignore – some browsers throw before metadata is loaded
  }

  const playPromise = audio.play();
  if (!playPromise || typeof playPromise.catch !== "function") {
    return Promise.resolve();
  }

  return playPromise.catch((error) => {
    if (error && error.name === "AbortError") {
      return;
    }
    console.error("Audio playback failed:", error);
    if (onError) onError(error);
  });
};
